/* eslint-disable import/no-unresolved */
import { Hint } from "@ui-kit/components/index.es";
import Card from "pages/_components/Card/Card";
import CardContainer from "pages/_components/Card/CardContainer";
import DrawerModal from "pages/_components/drawer/DrawerModal";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import InfoTag from "pages/_components/InfoTag";
import Spinner from "pages/_components/Spinner";
import EmittedContextMenu from "pages/checks/Echeqs/EmittedContextMenu";
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { actions, selectors } from "reducers/checks";
import { echeqShape, resolveEcheqRowLink, shouldShowPendingEcheqSignaturesHint, statusTagColor } from "util/checks";
import * as i18n from "util/i18n";
import { addPrivateShellScrollListener, readPrivateShellScrollTop } from "util/privateShellScrollTarget";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { V3_SCROLL_ROOT_ID } from "v3/constants";

const FORM_ID = "echeq";

class EmittedEcheqs extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        setSubmitting: func.isRequired,
        option: string.isRequired,
        echeqsList: arrayOf(echeqShape).isRequired,
        environmentCuit: string.isRequired,
        filters: shape({
            createdFrom: string.isRequired,
            createdTo: string.isRequired,
            payedFrom: string.isRequired,
            payedTo: string.isRequired,
            payedCheck: bool.isRequired,
            emitedCheck: bool.isRequired,
            receiver: string.isRequired,
            emitted: string.isRequired,
            status: shape({ value: string.isRequired, label: string.isRequired }).isRequired,
            number: string.isRequired,
            grouper: string.isRequired,
            id: string.isRequired,
            orderColumName: string.isRequired,
            orderDirection: string.isRequired,
        }).isRequired,
        isDesktop: bool.isRequired,
        hasMoreData: bool.isRequired,
        fetchNextTransactions: func.isRequired,
        orderByData: func.isRequired,
        currency: string.isRequired,
    };

    state = {
        showDrawer: false,
        contentDrawer: "",
        isAtTop: false,
    };

    componentDidMount() {
        const { filters, orderByData } = this.props;
        orderByData(filters.orderColumName, filters.orderDirection, this.changeFilter);
        this.syncPrivateShellScrollListener();
    }

    componentDidUpdate(prevProps) {
        const { isDesktop } = this.props;
        if (prevProps.isDesktop !== isDesktop) {
            this.syncPrivateShellScrollListener();
        }
    }

    componentWillUnmount() {
        if (this.removePrivateShellScrollListener) {
            this.removePrivateShellScrollListener();
            this.removePrivateShellScrollListener = null;
        }
    }

    syncPrivateShellScrollListener = () => {
        const { isDesktop } = this.props;
        if (this.removePrivateShellScrollListener) {
            this.removePrivateShellScrollListener();
            this.removePrivateShellScrollListener = null;
        }
        if (!isDesktop) {
            this.removePrivateShellScrollListener = addPrivateShellScrollListener(this.handleScrollCheck);
        }
    };

    changeFilter = (filterName, filterDirecion) => {
        const { filters, dispatch, option, setSubmitting, isDesktop, currency } = this.props;

        const filtersEcheq = {
            ...filters,
            option,
            status: filters.status,
            orderColumName: filterName,
            orderDirection: filterDirecion,
            pageNumber: 1,
            currency,
        };
        dispatch(actions.setEcheqFilters(filtersEcheq));
        dispatch(actions.setShowCleanFilterButton(true));
        setSubmitting(true);
        dispatch(actions.filterEcheqList(filtersEcheq, setSubmitting, isDesktop));
    };

    cardsEmittedEcheqs = () => {
        const { echeqsList, isDesktop, environmentCuit } = this.props;

        const listSorted = echeqsList;

        return listSorted.map((object) => {
            const beneficiaryDocument = object.beneficiario_documento_tipo
                .toUpperCase()
                .concat(" ", object.beneficiario_documento);
            const beneficiaryDocumentNumber = beneficiaryDocument.replace(/\D/g, "");

            return (
                <CardContainer
                    key={object.cheque_numero}
                    renderAs={Link}
                    to={resolveEcheqRowLink(object, `/echeqs/emitted/detail/${object.cheque_id}`)}>
                    <Card
                        title={
                            <div className="echeqs__cards-title">
                                <div className="d-flex echeqs__emmit-info">
                                    <I18n
                                        id="echeqs.emitedCheck.label"
                                        componentProps={{ className: "echeqs__emittedDate" }}
                                    />
                                    <FormattedDate date={object.fecha_emision} />
                                </div>
                                <div className="d-flex">
                                    <I18n
                                        id={`${FORM_ID}.paymentDate`}
                                        componentProps={{ className: "echeqs__paymentDate" }}
                                    />
                                    <FormattedDate date={object.fecha_pago} />
                                </div>
                            </div>
                        }
                        content={
                            <div className="echeqs__cards-content">
                                <span className="echeqs__echeqNumber">{object.cheque_numero}</span>
                                {object.tenencia_beneficiario_documento === environmentCuit && (
                                    <Image src="images/ownershipEcheqs.svg" />
                                )}
                            </div>
                        }
                        bottom={
                            <div className="echeqs__cards-bottom">
                                <div className="echeqs__beneficiary">
                                    <I18n
                                        id="echeq.beneficiary"
                                        componentProps={{ className: "echeqs__beneficiary-title" }}
                                    />
                                    <span>{object.beneficiario_nombre.replaceAll("#", "Ñ")}</span>
                                </div>
                                <I18n
                                    id={`${FORM_ID}.received.from.document`}
                                    componentProps={{ className: "echeqs__beneficiary-document" }}
                                />
                                <span className="echeqs__beneficiary-document-number">{beneficiaryDocumentNumber}</span>
                            </div>
                        }
                        rightContent={
                            <div className="echeqs__cards-rightContent">
                                <div className="echeqs__cards-right-info">
                                    {shouldShowPendingEcheqSignaturesHint(object) && (
                                        <div className="echeqs__pending-signatures-hint d-flex justify-content-end w-100">
                                            <Hint
                                                colorText="dark"
                                                colorIcon="dark"
                                                text={i18n.get("echeq.pending.signatures.hint")}
                                            />
                                        </div>
                                    )}
                                    <div className="echeqs__cards-amount">
                                        <FormattedAmount
                                            currency={i18n.get(
                                                "currency.label.".concat(object.moneda || object.emisor_moneda),
                                            )}
                                            quantity={object.monto}
                                        />
                                    </div>
                                    <div className="d-flex flex-column align-items-end">
                                        <InfoTag
                                            type="info"
                                            message={object.estado}
                                            tagBackground={statusTagColor(object.estado)}
                                            moreStyles={{
                                                alignSelf: "flex-end",
                                                width: "fit-content",
                                                color: "black",
                                                margin: "auto",
                                                marginRight: 0,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="echeqs__context-menu-container">
                                    <EmittedContextMenu
                                        echeq={object}
                                        isDesktop={isDesktop}
                                        setState={(newState) => this.setState(newState)}
                                    />
                                </div>
                            </div>
                        }
                    />
                </CardContainer>
            );
        });
    };

    echeqsListMobile = (echeq) => {
        const {
            cheque_numero: cheqNro,
            estado,
            monto,
            beneficiario_nombre: benefNombre,
            beneficiario_documento_tipo: typeDoc,
            beneficiario_documento: doc,
            emisor_moneda: emisorMoneda,
            fecha_pago: fechaPago,
            fecha_emision: fechaEmision,
            cheque_id: cheqId,
            moneda,
        } = echeq;

        const { isDesktop } = this.props;

        return (
            <CardContainer
                renderAs={Link}
                to={resolveEcheqRowLink(echeq, `/echeqs/emitted/detail/${cheqId}`)}
                className="px-3">
                <Card
                    hrClass="ml-2"
                    title={
                        <div className="d-flex w-100 space-between echeqs__cards-title">
                            <div className="d-flex w-100">
                                <I18n id="echeq.number" componentProps={{ className: "ml-2 echeq__info" }} />
                                <span className="echeq__data">{cheqNro}</span>
                            </div>
                            <EmittedContextMenu
                                echeq={echeq}
                                isDesktop={isDesktop}
                                setState={(newState) => this.setState(newState)}
                            />
                        </div>
                    }
                    content={
                        <div>
                            <hr className="ml-2" />
                            <div className="echeqs__cards-content">
                                <div className="d-flex space-between w-100 pb-1 align-items-center">
                                    <I18n id="echeqs.status.label" componentProps={{ className: "ml-2 echeq__info" }} />
                                    <div className="d-flex flex-column align-items-end">
                                        {shouldShowPendingEcheqSignaturesHint(echeq) && (
                                            <Hint
                                                colorText="dark"
                                                colorIcon="dark"
                                                text={i18n.get("echeq.pending.signatures.hint")}
                                            />
                                        )}
                                        <InfoTag
                                            type="info"
                                            message={estado}
                                            tagBackground={statusTagColor(estado)}
                                            tagClass="d-flex px-2 ml-2 my-0 mr-0"
                                            moreStyles={{
                                                color: "black",
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex space-between w-100">
                                    <I18n
                                        id="echeqs.emitedCheck.label"
                                        componentProps={{ className: "ml-2 echeq__info" }}
                                    />
                                    <FormattedDate date={fechaEmision} />
                                </div>
                                <div className="d-flex space-between w-100">
                                    <I18n
                                        id="echeqs.payedCheck.label"
                                        componentProps={{ className: "ml-2 echeq__info" }}
                                    />
                                    <FormattedDate showTime={false} date={fechaPago} />
                                </div>
                                <div className="d-flex space-between w-100 pt-1">
                                    <I18n id="echeq.beneficiary" componentProps={{ className: "ml-2 echeq__info" }} />
                                    <span className="echeq__data">{benefNombre.replaceAll("#", "Ñ")}</span>
                                </div>
                                <div className="d-flex space-between w-100 pt-1">
                                    <I18n
                                        id="echeqs.document.label"
                                        componentProps={{ className: "ml-2 echeq__info" }}
                                    />
                                    <span className="echeq__data">{`${typeDoc.toUpperCase()} ${doc}`}</span>
                                </div>
                            </div>
                        </div>
                    }
                    rightContent={
                        <div className="echeqs__cards-rightContent">
                            <FormattedAmount
                                currency={i18n.get("currency.label.".concat(moneda || emisorMoneda))}
                                quantity={monto}
                                notBold={isDesktop}
                                className="echeq__data"
                            />
                        </div>
                    }
                />
            </CardContainer>
        );
    };

    handleScrollCheck = () => {
        const scrollTopPosition = readPrivateShellScrollTop();

        // Artificio para evitar recarga de informacion al inicio de la pantalla
        const currentlyAtTop = scrollTopPosition < 5;

        const { isAtTop } = this.state;
        if (currentlyAtTop !== isAtTop) {
            this.setState({ isAtTop: currentlyAtTop });
        }
    };

    render() {
        const { echeqsList, isDesktop, hasMoreData, fetchNextTransactions } = this.props;
        const { showDrawer, contentDrawer, title } = this.state;

        const endOfListItem = (
            <div className="table-row table-end mb-5" key="noMoreTransactions">
                <I18n id="echeqs.noMoreEcheqs" />
            </div>
        );

        const { isAtTop } = this.state;
        if (!isDesktop) {
            return (
                <>
                    <InfiniteScroll
                        dataLength={echeqsList.length}
                        next={() => {
                            if (!isAtTop) {
                                fetchNextTransactions();
                            }
                        }}
                        hasMore={hasMoreData}
                        loader={<Spinner />}
                        endMessage={endOfListItem}
                        initialLoad={false}
                        scrollableTarget={isUxDashboardImprovementsEnabled() ? V3_SCROLL_ROOT_ID : undefined}>
                        {echeqsList.map((echeq) => this.echeqsListMobile(echeq))}
                    </InfiniteScroll>
                    {showDrawer && (
                        <DrawerModal
                            content={contentDrawer}
                            width={isDesktop ? "600px" : "100vw"}
                            title={title}
                            headerContent={
                                !isDesktop && (
                                    <div className="toolbar-item view-title align-self-center mx-0">
                                        <I18n
                                            id={title}
                                            component="h1"
                                            componentProps={{
                                                className:
                                                    "title-content header-mobile-title-background-blue align-self-center mb-0",
                                            }}
                                        />
                                    </div>
                                )
                            }
                            isDesktop={isDesktop}
                            navbarHeaderClassName="mt-3"
                            showDrawerRemote={showDrawer}
                            closeRemotely={() => this.setState({ showDrawer: false, contentDrawer: "" })}
                            drawerClassName="echeq__drawer"
                        />
                    )}
                </>
            );
        }

        return (
            <div className="flex-grow">
                <div className="px-4">
                    <Col xs={12} className="px-0">
                        <div
                            style={{ borderSpacing: "0px 2px", width: "100%", minHeight: "520px" }}
                            ref={(tableRef) => {
                                this.child = tableRef;
                            }}>
                            <div className="flex-grow align-items-center container scrolleable form-content">
                                <div className="row justify-content-center">{this.cardsEmittedEcheqs()}</div>
                            </div>
                            {showDrawer && (
                                <DrawerModal
                                    content={contentDrawer}
                                    width={isDesktop ? "600px" : "100vw"}
                                    title={title}
                                    headerContent={
                                        !isDesktop && (
                                            <div className="toolbar-item view-title align-self-center mx-0">
                                                <I18n
                                                    id={title}
                                                    component="h1"
                                                    componentProps={{
                                                        className:
                                                            "title-content header-mobile-title-background-blue align-self-center mb-0",
                                                    }}
                                                />
                                            </div>
                                        )
                                    }
                                    isDesktop={isDesktop}
                                    navbarHeaderClassName="mt-3"
                                    showDrawerRemote={showDrawer}
                                    closeRemotely={() => this.setState({ showDrawer: false, contentDrawer: "" })}
                                    drawerClassName="echeq__drawer"
                                />
                            )}
                        </div>
                    </Col>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    echeqsList: selectors.getEcheqsList(state),
    environmentCuit: selectors.getEnvironmentCuit(state),
    hasMoreData: selectors.getHasMoreData(state),
});

export default connect(mapStateToProps)(EmittedEcheqs);
